import { EColorVariablesV2 } from '@/types/theme-packs.types';

const getThemeColorsCssMixVariable = (props?: { variableName?: EColorVariablesV2; mix?: 10 | 20 | 30 }) => {
  const { variableName = EColorVariablesV2.primary, mix = 20 } = props || {};

  return `var(--project-theme-color-${variableName}-mix-${mix})`;
};

export default getThemeColorsCssMixVariable;
